var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import cls from 'classnames';
import { Button, ButtonGroup, Popup, tools } from 'rcm-mobile';
import './style/index.scss';
let getUuid;
let rootElement;
const actionSheetInstance = {};
/**
 * @author sayll
 * @version 0.0.1
 */
export default class ActionSheet extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.lock = false; // 反正重复触发
    }
    render() {
        const _a = this.props, { prefixCls, className, title, actions, onBeforeOk, type, onOk, onCancel } = _a, resetProps = __rest(_a, ["prefixCls", "className", "title", "actions", "onBeforeOk", "type", "onOk", "onCancel"]);
        return (<div className={cls(prefixCls, className, { [`${prefixCls}-theme-${type}`]: type })} {...resetProps}>
        {title && <h2 className={cls(`${prefixCls}-title`)}>
          <div className="x-ellipsis" style={{ width: '18em', margin: '0 auto' }}>{title}</div>
        </h2>}

        <ButtonGroup size="large" inline={false} className={cls(`${prefixCls}-actions`)}>
          {(actions || [])
            .sort((i, k) => !i.disabled && !k.disabled ? 0 : i.disabled ? 1 : -1)
            .map((action, key) => (<Button key={`action-${key}`} className={cls(`${prefixCls}-actions-button`, { [`x-disabled`]: action.disabled })} style={action.style} onClick={() => __awaiter(this, void 0, void 0, function* () {
            if (this.lock || action.disabled)
                return;
            if (onBeforeOk && (yield onBeforeOk(action)) === false)
                return this.lock = false;
            this.lock = true;
            action.onClick && action.onClick(action);
            onOk && onOk(action);
        })}>
                <span className={`${prefixCls}-actions-logo`}>{action.logo}</span>
                <div className={`${prefixCls}-actions-text`}>
                  <span>{action.text}</span>
                </div>
              </Button>))}
        </ButtonGroup>

        <Button size="large" className={cls(`${prefixCls}-cancel`)} onClick={onCancel}>取消</Button>
      </div>);
    }
    static create(actions, title, onOk, options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!rootElement) {
                rootElement = document.createElement('div');
                rootElement.className = `${ActionSheet.defaultProps.prefixCls}-root`;
                document.body.appendChild(rootElement);
            }
            getUuid = getUuid || tools.helper.getUuidFn(ActionSheet.defaultProps.prefixCls);
            const key = getUuid();
            const _a = options || {}, { title: _title, type, onBeforeOk, onOk: _onOk, onCancel, actions: _actions } = _a, resetProps = __rest(_a, ["title", "type", "onBeforeOk", "onOk", "onCancel", "actions"]);
            if (options) {
                actions = _actions || actions;
                title = _title || title;
                onOk = _onOk || onOk;
            }
            const sender = yield Popup.create(Object.assign({ content: () => <ActionSheet type={type} title={title} actions={actions} onBeforeOk={onBeforeOk} onOk={action => {
                    onOk && onOk(action);
                    sender.destroy();
                }} onCancel={() => {
                    onCancel && onCancel();
                    sender.destroy();
                }}/>, mask: true, onClickMask: () => sender.destroy(), animation: 'bottom', offset: {
                    bottom: 0,
                    left: 0,
                    right: 0
                } }, resetProps, { rootElement }));
            return actionSheetInstance[key] = sender;
        });
    }
    static showAction(actions, title, onOk, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return ActionSheet.create(actions, title, onOk, Object.assign({ type: 'action' }, options));
        });
    }
    static showActionShare(actions, title, onOk, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return ActionSheet.create(actions, title, onOk, Object.assign({ type: 'actionShare' }, options));
        });
    }
    /**
     * 卸载所有ActionSheet
     * @public
     * */
    static destroy() {
        return __awaiter(this, void 0, void 0, function* () {
            let sender;
            for (let key in actionSheetInstance) {
                sender = yield actionSheetInstance[key];
                sender.destroy();
                delete actionSheetInstance[key];
            }
        });
    }
}
ActionSheet.defaultProps = {
    prefixCls: 'x-action-sheet'
};
